export default "__VITE_ASSET__DImEsBgr__"